import React from "react";
import Login from "./Login";

function AdminLogin() {
  return <Login role="admin" />;
}

export default AdminLogin;
